import { FLIGHT_INDICATOR, TERMINAL_ID } from "@/constants/EngineConstants";
import { Offer } from "@/types/offer";
import { replaceBookingUrl } from "@/utils/urlUtils";

export interface DestinationUI {
  id: string;
  city: string;
  country: string;
  image: string;
  priceUSD: number;
  url: string;
  flightIndicator: string;
}

export const mapOfferToDestination = (offer: Offer): DestinationUI => ({
  id: `${offer.originId}-${offer.destinationId}`,
  city: offer.destination,
  country: offer.flightType === "DOMESTIC" ? "Perú" : "Internacional",
  image: offer.imageUrl,
  priceUSD: offer.price,
  url: `${replaceBookingUrl(offer.url)}?terminalId=${TERMINAL_ID}`,
  flightIndicator: FLIGHT_INDICATOR[offer.flightIndicator]
});
